var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"delivery-bottom",staticStyle:{"width":"45%"}},[_c('router-link',{staticClass:"page-back",attrs:{"to":"/shipping","exact":""}},[_vm._v("Previous")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }